import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4100e194"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"margin-top":"50px"} }
const _hoisted_2 = { class: "aigame-rank-subtitle" }
const _hoisted_3 = { class: "aigame-rank-table" }
const _hoisted_4 = { class: "aigame-rank-table-thbox" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "aigame-rank-table-tbody" }
const _hoisted_7 = { class: "aigame-rank-table-thead" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "aigame-rank-table-td" }, "暂无数据", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 1,
  style: {"color":"green"}
}
const _hoisted_15 = {
  key: 2,
  style: {"color":"red"}
}
const _hoisted_16 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.stageItem[_ctx.stage - 1]), 1),
      (_ctx.showButton)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "aigame-rank-button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clickRankDetail(_ctx.stage)))
          }, "详细信息"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trackTitle, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            onClick: ($event: any) => (_ctx.clickTrack(_ctx.stage, index)),
            class: _normalizeClass(['aigame-rank-table-th', _ctx.activeTrack === index ? 'cur' : ''])
          }, _toDisplayString(item), 11, _hoisted_5))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rankItem, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "aigame-rank-table-subth"
            }, _toDisplayString(item), 1))
          }), 128))
        ]),
        (_ctx.currentRank.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentRank, (team, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "aigame-rank-table-tr"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(team, (val, ind) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: ind,
                      class: "aigame-rank-table-td t-big"
                    }, [
                      (ind === 0 && typeof val === 'string')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createElementVNode("img", {
                              src: val,
                              alt: "",
                              class: "aigame-rank-table-number"
                            }, null, 8, _hoisted_13)
                          ]))
                        : (ind === 2 && val < 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(val), 1))
                          : (ind === 2 && val > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, "+" + _toDisplayString(val), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(val), 1))
                    ]))
                  }), 128))
                ]))
              }), 128))
            ]))
      ])
    ])
  ]))
}